import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';

class StockValueStore extends EventEmitter {
    PageLoadData = "";
    Excel = "";
    Total = "";
    GridData = "";
    Insertfav = "";
    deletefav = "";
    Notifyfav = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleStockValueReport = (action) => {
        
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        switch (action.action.type) {
            case "BuData": {
                this.PageLoadData = action.action.response;
                this.emit('BuData');
                break;
            }
            case "Export": {
                this.Excel = action.action.response;
                ;
                this.emit('Export');
                break;
            }
            case "GridData": {
                this.GridData = action.action.response;
                this.emit('GridData');
                break;
            }
            case "Total": {
                this.Total = action.action.response;
                this.emit('Total');
                break;
            }
            case "StkValue_InsertFavPage": {
                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "StkValue_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "StkValue_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
        }
    }
}
const objStockValueStore = new StockValueStore;
// Dispatcher code
Dispatcher.register(objStockValueStore.handleStockValueReport.bind(objStockValueStore));
export default objStockValueStore;